import { CHARGEBEE_SITE_URL, CHARGEBEE_ENABLE_GA_TRACKING, CHARGEBEE_ENABLE_REFERSION_TRACKING } from '../../config';

export const ChargeBee = window.Chargebee && window.Chargebee.init({
	site: CHARGEBEE_SITE_URL,
	enableGATracking: CHARGEBEE_ENABLE_GA_TRACKING,
	enableRefersionTracking: CHARGEBEE_ENABLE_REFERSION_TRACKING
});


// WEBPACK FOOTER //
// ./src/redux/modules/chargebee.js